import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
  accent?: 'blue' | 'green' | 'gold';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  blue: 'bg-brand-blue',
  green: 'bg-brand-green',
  gold: 'bg-brand-goldDark'
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text,
  accent = 'blue'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-blueMid p-6 md:p-8" data-id="element-339" data-mp="31ybfdecf3hhl">
      <div className="mb-4 flex items-center" data-id="element-340" data-mp="2x2w2aom8hpm8">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-341" data-mp="2s2i561m6802z">
          {initials}
        </div>
        <div data-id="element-342" data-mp="qbn52xkxleqg">
          <div className="mb-1 flex text-brand-amber" data-id="element-343" data-mp="qb51ffvxvy8i">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-344" data-mp="h8ayfe0pcrr8" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-345" data-mp="m6cdzoyx68xy">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-346" data-mp="7926eqpedn7i">
            {location}
            {product ? ` — ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-347" data-mp="zvwfkrgrl05o">“{text}”</p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'México',
  product: 'Terapeuta holística',
  accent: 'blue',
  text: 'Por primera vez tengo un sistema para mis sesiones. Ya no busco entre apuntes: abro el Tomo II y sé por dónde empezar la exploración. Cuando muestro el mapa visual del cuerpo, el consultante percibe que hay un método detrás.'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  location: 'Colombia',
  product: 'Terapeuta',
  accent: 'green',
  text: 'El Tomo III de prácticas de integración vale todo el kit. Antes no sabía cómo cerrar. Ahora selecciono el recurso según lo que trabajamos y la sesión termina con estructura.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Perú',
  product: 'Terapeuta en formación',
  accent: 'gold',
  text: 'Recién comenzaba y el Radar de Preguntas Gatillo me salvó varias consultas. Lo tengo abierto al lado y ya no me quedo en blanco. Además, el Cuaderno del Paciente hace que lleguen con su información ordenada.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-348" data-mp="14sk0cs4jz79t">
      <div className="mx-auto max-w-3xl" data-id="element-349" data-mp="14tlbsxphdvs2">
        <TestimonialCard {...testimonials[0]} data-id="element-350" data-mp="10s03lpnw65o7" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-351" data-mp="vswxs3037vf6">
      <div className="mb-10 text-center" data-id="element-352" data-mp="vrvjzqrosutr">
        <h2 className="font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-353" data-mp="qtu41epk5bmi">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-354" data-mp="32j078v0el7bn">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-355" data-mp="3cf3lgz8j4wey" />)}
      </div>
    </Section>;
}